import { CmsComponentProps, ISize } from '@/types/cms';
import classNames from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import { FC, useEffect, useRef, useState } from 'react';

import { twMerge } from 'tailwind-merge';

const Text: FC<CmsComponentProps> = props => {
  const { properties } = props;
  const { t } = useTranslation('common');
  const [expand, setExpend] = useState(false);
  const [more, setMore] = useState(false);
  const containerRef = useRef(null);
  const contentRef = useRef(null);

  const handleMore = () => {
    setExpend(!expand);
  };

  useEffect(() => {
    if (containerRef && contentRef && !!+properties?.display_line) {
      const containerDom = containerRef.current?.getBoundingClientRect();
      const contentDom = contentRef.current?.getBoundingClientRect();
      // 容器高度与内容高度相差大于默认字体高度，显示更多提示
      const diff = Math.abs(contentDom?.height - containerDom?.height) > 14;
      if (diff) {
        setMore(true);
      }
    }
  }, [containerRef.current, contentRef.current, properties?.display_line]);

  return (
    <div
      data-module={props.cmsComponentKey}
      style={{
        fontWeight: properties?.font_weight as any,
        padding: more ? '0 20px 40px' : '0 20px 5px'
      }}
      className={twMerge(
        classNames('relative tracking-[0.38px] mx-0 my-2.5', {
          'my-2.5': properties?.vertical_margin === ISize.small,
          'my-5': properties?.vertical_margin === ISize.middle,
          'my-10': properties?.vertical_margin === ISize.large,
          ['text-sm']: properties?.font_size === (ISize.small as string),
          ['text-base']: properties?.font_size === (ISize.middle as string),
          ['text-xl']: properties?.font_size === (ISize.large as string)
        })
      )}>
      {properties?.text && properties?.text?.includes('\n') ? (
        <div className="text-ellipsis overflow-hidden" style={{ WebkitBoxOrient: 'vertical', display: '-webkit-box' }}>
          <span dangerouslySetInnerHTML={{ __html: properties?.text?.replace(/\n/g, '<br />') }}></span>
        </div>
      ) : (
        <div
          ref={containerRef}
          style={{
            WebkitBoxOrient: 'vertical',
            display: '-webkit-box',
            color: `${properties?.color}`,
            textAlign: properties?.align,
            fontStyle: properties?.italic,
            WebkitLineClamp: !expand && properties?.display_line && +properties?.display_line
          }}
          className="text-ellipsis overflow-hidden">
          <span ref={contentRef}>{properties?.text}</span>
        </div>
      )}

      {more && (
        <span onClick={handleMore} className="absolute font-semibold right-[18px] bottom-5">
          {expand ? t('brand_show_less') : t('brand_show_more')}
        </span>
      )}
    </div>
  );
};

export default Text;
